<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="px-1">
            <div class=" row col-xl-12  mx-0 px-0 ">
               
                    <div class="row  col-xl-12  mx-0 px-0 mt-2">
                        <div class="col-xl-6 px-1">
                            <h6>Productos no Selecionados</h6>
                            
                            <div class="col-md-12 table-responsive" id="div-tabla-anular">
                                <div class="input-group input-group mb-2">
                                    <span class="input-group-text  text-white bg-dark"><i class="fas fa-search"></i></span>
                                    <input v-model="search" type="text" class="form-control-sm form-control" placeholder="Escriba un producto no seleccionado para realizar la búsqueda" @input="calculateData(0)" />
                                </div>
                                <table id="tb-anular" class="table  table-bordered" style="font-size: 11px;">
                                    <caption class="mx-0 px-0"></caption>
                                    <thead class="text-xxs table-dark">
                                        <tr class="text-white">
                                            <th scope="col" class="align-middle">N°</th>
                                            <th scope="col" class="align-middle">NOMBRE</th>
                                            <th scope="col" class="align-middle">UNIDAD</th>
                                            <th scope="col" class="align-middle">P. VENTA</th>
                                            <th scope="col" class="align-middle">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody class="border-main text-xxs">
                                        <tr class="tbody-table" v-for="(item, index) in servicios_no_seleccionado" :key="index">
                                            <td class="align-middle">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="align-middle">
                                                {{ item.product.name}}
                                            </td>
                                            <td class="align-middle">
                                                {{ item.unit.name}}
                                            </td>
                                            <td class="align-middle">
                                                {{ item.price_purchase}}
                                            </td>
    
                                            <td class="align-middle text-center" @click="mtdnoselecionado(item)">
                                                <button type="button" class=" btn btn-success btn-sm px-1 py-0 ">
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="!servicios_no_seleccionado.length > 0" class="text-center">
                                            <th scope="col" colspan="5">No hay registros</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-xl-6 px-0">
                            <h6>Productos Seleccionados</h6>
                            <div class="col-md-12 table-responsive" id="div-tabla-anular">
                                <div class="input-group input-group mb-2">
                                    <span class="input-group-text  text-white bg-dark"><i class="fas fa-search"></i></span>
                                    <input v-model="search1" type="text" class="form-control-sm form-control" placeholder="Escriba un medicamento no seleccionado para realizar la búsqueda" @input="calculateData(1)" />
                                </div>
                                <table id="tb-anular" class="  table table-bordered" style="font-size: 11px;">
                                    <caption class="mx-0 px-0"></caption>
                                    <thead class=" table-dark text-xxs">
                                        <tr class="text-white">
                                            <th scope="col" class="align-middle">N°</th>
                                            <th scope="col" class="align-middle">NOMBRE</th>
                                            
                                            <th scope="col" class="align-middle">UNIDAD</th>
                                            <th scope="col" class="align-middle">P. VENTA</th>
                                            <th scope="col" class="align-middle">CANTIDAD</th>
                                            <th scope="col" class="align-middle">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody class="border-main text-xxs">
                                        <tr class="tbody-table" v-for="(item, index) in servicios_seleccionado" :key="index">
                                            <td class="align-middle">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="align-middle">
                                                {{ item.product.name}}
                                            </td>
                                            <td class="align-middle">
                                                {{ item.unit.name}}
                                            </td>
                                            <td class="align-middle" @dblclick="mtdSelectInput(index)">
                                                <span v-if="posEdit != index">{{ item.price_purchase}} </span>
                                                <input v-else type="text" class="form-control text-center form-control-sm w-100" v-model="newPrice" @keyup.enter="mtdOutFocusEditPrice" @blur="mtdOutFocusEditPrice" @input="validateAmount" placeholder="0.00" />
                                            </td>
                                            <td class="align-middle" @dblclick="mtdSelectInputQuantity(index)">
                                                <span v-if="posEditquantity != index">{{ item.quantity}} </span>
                                                <input v-else type="text" class="form-control text-center form-control-sm w-100" v-model="newquantity" @keyup.enter="mtdOutFocusEditQuantity" @blur="mtdOutFocusEditQuantity" @input="validateAmount" placeholder="1" />
                                            </td>
                                            <td class="align-middle text-center">
                                                <button type="button" class=" btn btn-danger btn-sm px-1 py-0" @click="mtdselecionado(item)">
                                                    <i class="fas fa-minus"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="!servicios_seleccionado.length > 0" class="text-center">
                                            <th scope="col" colspan="6">No hay registros</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
    
                        </div>
                    </div>
    
    
            </div>
        </div>
        <template #footer>
            <button @click="mtdClose" class="btn btn-danger btn-sm">
                <i class="fa fa-times" />&nbsp;Cerrar
            </button>
            <button class="btn btn-success btn-sm" @click="mtdaddservicios">
                Registrar
            </button>
            &nbsp;
        </template>
    
    </CModal>
    </template>
    
    <script>
      import CModal from "../../shared/modals/cModalFormCom.vue";
    
    import {
        mapActions
    } from "vuex";
    
    export default {
        name: "c-maintenance-modal-marca",
        components: {
            CModal,
    
        },
        data() {
            return {
                posEdit: null,
                oldPrice: null,
                services_provider: {
                    id: null,
                    products: []
                },
                servicios_seleccionado: [],
                servicios_no_seleccionado: [],
                newPrice: null,
                posEditquantity:null,
                newquantity:null,
                oldquantity:null,
                search:'',
                search1: '',
                dataoriginal_noselecionado: [],
                dataoriginal_selecionado: []
            };
        },
    
        props: {
            title: String,
            boo_modal: Boolean,
    
            provider_id: {
                type: Number,
                default: null
            },
            id_campu:Number
    
        },
        watch: {
            provider_id(newValue, oldValue) {
                if (newValue !== null) {
                    this.mtdservicio();
                }
            }
        },
    
        methods: {
            ...mapActions(["get", "post"]),
    
            mtdClose() {
                this.servicios_seleccionado = []
                this.servicios_no_seleccionado = []
                this.marca = {
                    id: '',
                    name: ''
                }
                this.search1 = '',
                this.search = '',
                this.posEditquantity =null,
                this.posEdit = null;
                this.$emit("closeModalService");
            },
            calculateData(item) {
   
                let dataProductos = (item == 0) ? this.servicios_no_seleccionado : this.servicios_seleccionado;
                let buscar = (item == 0) ? this.search : this.search1;
                if (buscar.length >= 2 && buscar != "") {
                    let query = buscar.toString().toUpperCase();
                    let filteredData = dataProductos.filter((element) => {
                        let name = element.product.name.toString().toUpperCase();
                        return name.includes(query);
                    });

                    if (item == 0) {
                        this.servicios_no_seleccionado = filteredData;
                      
                    } else {
                        this.servicios_seleccionado = filteredData;
                    }
                } else {
                    if (item == 0) {
                        this.servicios_no_seleccionado = this.dataoriginal_noselecionado;
                    } else {
                        this.servicios_seleccionado = this.dataoriginal_selecionado;
                    }
                }

                },
    
            mtdservicio: function () {
              
                this.post({
                        url: this.$store.getters.get__url + "/kits/products",
                        token: this.$store.getters.get__token,
                        params: {
                            id: this.provider_id,
                            campu_id:this.id_campu,
                        }
                    })
                    .then(response => {
    
                        this.servicios_seleccionado = response.data.productos_seleccionado;
                        this.servicios_no_seleccionado = response.data.productos_no_seleccionado;
                        this.dataoriginal_selecionado = response.data.productos_seleccionado
                        this.dataoriginal_noselecionado = response.data.productos_no_seleccionado;
                    })
                    .catch(error => {
                       
                    })
            },
            mtdnoselecionado: function (item) {
                const index = this.servicios_no_seleccionado.findIndex(servicio => servicio.id === item.id);
                if (index !== -1) {
                    const ServicioQuitado = this.servicios_no_seleccionado.splice(index, 1)[0];
                    this.servicios_seleccionado.push(ServicioQuitado);
                }
    
            },
            mtdselecionado: function (item) {
                const index = this.servicios_seleccionado.findIndex(servicio => servicio.id === item.id);
                if (index !== -1) {
                    const ServicioQuitado = this.servicios_seleccionado.splice(index, 1)[0];
                    this.servicios_no_seleccionado.push(ServicioQuitado);
                }
            },
            mtdaddservicios: function () {
                this.services_provider = {
                    id: this.provider_id,
                    services: this.servicios_seleccionado,
                }
                this.servicios_seleccionado = []
                this.servicios_no_seleccionado = []
    
                this.$emit('mtdaddservicios', this.services_provider);
            },
            mtdSelectInput: function (pos) {
                this.posEdit = pos;
                this.oldPrice = this.servicios_seleccionado[pos].price_purchase;
                this.newPrice = this.servicios_seleccionado[pos].price_purchase;
          
            },
            mtdSelectInputQuantity:function (pos) {
                this.posEditquantity = pos;
                this.oldquantity = this.servicios_seleccionado[pos].quantity;
                this.newquantity = this.servicios_seleccionado[pos].quantity;
        
            },
            mtdOutFocusEditPrice: function () {
       
                if (this.oldPrice != this.newPrice && this.newPrice > 0) {
                    Swal.fire({
                        icon: "warning",
                        title: "¿Desea cambiar este precio?",
                        width: "400px",
                        /** buttons */
                        showDenyButton: true,
                        denyButtonText: `Rechazar`,
                        denyButtonColor: "#bb8a17",
                        confirmButtonText: "Permitir",
                        confirmButtonColor: "#3085d6",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // this.mtdCommitEditPrice();
                            this.servicios_seleccionado[this.posEdit].price_purchase = this.newPrice
                            this.posEdit = null;
                            
                        } else if (result.isDenied) {
                            this.posEdit = null;
                            this.oldPrice = null;
                            this.newPrice = null;
                        }
                    });
                } else {
                    this.posEdit = null;
                    this.oldPrice = null;
                    this.newPrice = null;
                }
            },
            mtdOutFocusEditQuantity: function () {
                
                if (this.oldquantity != this.newquantity && this.newquantity > 0) {
                    Swal.fire({
                        icon: "warning",
                        title: "¿Desea cambiar esta cantidad?",
                        width: "400px",
                        /** buttons */
                        showDenyButton: true,
                        denyButtonText: `Rechazar`,
                        denyButtonColor: "#bb8a17",
                        confirmButtonText: "Permitir",
                        confirmButtonColor: "#3085d6",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.servicios_seleccionado[this.posEditquantity].quantity = this.newquantity
                            this.posEditquantity = null;
                            
                        } else if (result.isDenied) {
                            this.posEditquantity = null;
                            this.oldquantity = null;
                            this.newquantity = null;
                        }
                    });
                } else {
                    this.posEditquantity = null;
                    this.oldquantity = null;
                    this.newquantity = null;
                }
            },
            validateAmount(event) {
                let sanitizedValue = event.target.value.replace(/[^0-9.]/g, '');
    
                const decimalCount = sanitizedValue.split('.').length - 1;
                if (decimalCount > 1) {
                    sanitizedValue = sanitizedValue.slice(0, -1);
                }
                const decimalIndex = sanitizedValue.indexOf('.'); // Limitar a dos decimales
                if (decimalIndex !== -1) {
                    const decimalPart = sanitizedValue.substring(decimalIndex + 1);
                    sanitizedValue = `${sanitizedValue.substring(0, decimalIndex)}.${decimalPart.substring(0, 2)}`;
                }
    
                this.newPrice = sanitizedValue;
            },
            // mtdCommitEditPrice: function () {
                 
            //     this.post({
            //             url: this.$store.getters.get__url + "/logistics/maintenance/update/priceservice",
            //             token: this.$store.getters.get__token,
            //             params: {
            //                 service: this.servicios_seleccionado[this.posEdit].id,
            //                 provider: this.provider_id,
            //                 price: this.newPrice,
            //             },
            //         })
            //         .then((response) => {
            //             if (response.statusCode == 200) {
            //                 this.servicios_seleccionado[this.posEdit].price_purchase = parseFloat(this.newPrice).toFixed(2);
            //                 this.posEdit = null;
            //                 this.oldPrice = null;
            //                 this.newPrice = null;
            //                 Swal.fire({
            //                     icon: "success",
            //                     title: "Editado correctamente",
            //                     showConfirmButton: false,
            //                     timer: 1500,
            //                 });
    
            //             } else {
            //                 Swal.fire({
            //                     title: "Error",
            //                     text: "",
            //                     icon: "error",
            //                     // width: "400px",
            //                     confirmButtonColor: "rgb(67,81,122)",
            //                 });
            //             }
            //         })
            //         .catch((errors) => {
            //             Swal.fire({
            //                 title: "Error",
            //                 text: errors,
            //                 icon: "error",
            //                 // width: "400px",
            //                 confirmButtonColor: "rgb(67,81,122)",
            //             });
            //         });
            // },
    
        },
    
    };
    </script>
    